
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8zun0", function(module, exports) {

$parcel$export(module.exports, "CommentsSection", () => $cf0560c30ac3d0d5$export$f8e6a933238e6d73);

var $gwFzn = parcelRequire("gwFzn");
const $cf0560c30ac3d0d5$export$f8e6a933238e6d73 = ({ contentId: contentId, classicComments: classicComments, handlePageCommentsRender: handlePageCommentsRender })=>{
    return classicComments ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(classicComments, {
        contentId: contentId,
        handlePageCommentsRender: handlePageCommentsRender
    }) : null;
};

});


//# sourceMappingURL=CommentsSection.159e2034.js.map
